import { Component, Mixins } from "vue-property-decorator";
import SpecialInitiatives from "@/mixins/http/SpecialInitiatives";
import store from "@/store";

@Component
class SpecialInitiativesService extends Mixins(SpecialInitiatives) {
  created() {
    this.$store = store;
  }

  lastPublishedDate() {
    return this.getLastPublishedDate("GET_LAST_PUBLISHED_DAYS");
  }

  loadCompaniesTopInvestors(filters: any) {
    return this.getCompaniesTopInvestors(filters);
  }

  loadBrandsTopInvestors(filters: any) {
    return this.getBrandsTopInvestors(filters);
  }

  loadProductsTopInvestors(filters: any) {
    return this.getProductsTopInvestors(filters);
  }
}

export default new SpecialInitiativesService();
